<template>
    <form method="post" :action="prop_url_login" id="form_login">
        <input type="hidden" name="_token" :value="csrf">
        <div class="input-box">
            <label class="label-text">{{ lang('username') }}</label>
            <div class="form-group">
                <span class="la la-user form-icon"></span>
                <input class="form-control"
                       :class="{'is-invalid': emailError !== null}"
                       type="text" name="email" :placeholder="lang('type_your_username')" v-model="email">
                <div class="invalid-feedback">
                    {{ emailError }}
                </div>
            </div>
        </div>
        <div class="input-box">
            <label class="label-text">{{ lang('password') }}</label>
            <div class="form-group mb-2">
                <span class="la la-lock form-icon"></span>
                <input class="form-control"
                       :class="{'is-invalid': passwordError !== null}"
                       type="password" name="password" :placeholder="lang('type_your_password')" v-model="password">
                <div class="invalid-feedback">
                    {{ passwordError }}
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
                <div class="custom-checkbox mb-0">
                    <input type="checkbox" id="rememberchb" name="remember">
                    <label for="rememberchb">{{ lang('remember_me') }}</label>
                </div>
                <p class="forgot-password">
                    <a :href="prop_url_password_request">{{ lang('forgot_password') }}</a>
                </p>
            </div>
        </div>
        <div class="btn-box pt-3 pb-1">
            <button type="button" class="theme-btn w-100" @click="submitForm()">{{ lang('login_account') }}</button>
        </div>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                email: '',
                emailError: null,
                password: '',
                passwordError: null,
            }
        },

        props: {
            prop_url_login: {
                required: true,
                type: String
            },
            prop_url_password_request: {
                required: true,
                type: String
            },
            prop_lang: {
                required: true,
                type: Object
            },
        },
        mounted() {
            console.log('Component mounted.')
        },

        methods: {
            submitForm() {
                let _self = this;

                let bodyFormData = new FormData();
                bodyFormData.append('email', this.email);
                bodyFormData.append('password', this.password);

                this.emailError = null;
                this.passwordError = null;

                axios.post(this.prop_url_login, bodyFormData, {
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'Accept': 'application/json'
                    },
                }).then(response => {
                    location.reload();
                }).catch(error => {
                    if (error.response.status === 422) {
                        $.each(error.response.data.errors, function (key, value) {
                            if(key === 'email'){
                                _self.emailError = value[0];
                            }
                            if(key === 'password'){
                                _self.passwordError = value[0];
                            }
                        });
                    }
                }).finally(() => {

                });
            },

            lang(key){
                if (this.prop_lang.hasOwnProperty(key)){
                    return this.prop_lang[key];
                } else {
                    return 'invalid_key: ' + key;
                }
            }
        }
    }
</script>
